export default "__VITE_ASSET__d608dce0__"